import React from 'react';
import { Section, FadeIn } from './ui';
import { Star } from 'lucide-react';
export const EarlyAdopterSection = () => {
  return <Section bg="bg-cream-light" data-id="element-78">
      <FadeIn data-id="element-79">
        <div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-md border border-cream-dark p-10 md:p-16 text-center" data-id="element-80">
          <div className="w-16 h-16 bg-gold-light/30 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-81">
            <Star className="w-8 h-8 text-gold fill-gold" data-id="element-82" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-brown" data-id="element-83">
            ESTÁS ENTRE LAS PRIMERAS
          </h2>
          <div className="space-y-4 text-lg text-brown-light max-w-2xl mx-auto" data-id="element-84">
            <p data-id="element-85">
              Este es un lanzamiento nuevo. Tú podrías ser una de las primeras
              mujeres 50+ en aplicar el Plan de 21 Días de Vitalidad y
              experimentar sus resultados.
            </p>
            <p data-id="element-86">Por eso, durante este lanzamiento, el precio es especial.</p>
            <p data-id="element-87">
              Tu opinión y tus resultados nos ayudarán a seguir mejorando este
              método para miles de mujeres 50+.
            </p>
          </div>
        </div>
      </FadeIn>
    </Section>;
};